var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"linear-gradient(130deg, #FF0099, #493240)"}},[_c('AppBar'),_c('SplashPageComponents')],1)}
var staticRenderFns = []

export { render, staticRenderFns }